import { faEye, faRotateLeft,faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
import { Button, Modal, Table } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";
import { Card, CardBody, CardHeader, CardTitle, Col, Row } from "reactstrap";
import {
  useGetAllAssetsOfUsersQuery,
  useGetImagePathByIdQuery,
} from "./farmerApiSlice";
import FarmerCattleMap from "./FarmerCattleMap";
import FarmerNoResponse from "./FarmerNoResponse";
import { LoaderDesign } from "./LoaderDesign";
import CardSkeleton from "components/CardSkeleton";
import CustomTextField from "components/CustomTextField";
import { Divider } from "@mui/material";
const FarmerDetailsCattle = ({ DocData }) => {
  const { id } = useParams();
  const [docModal, setDocModal] = useState(false);
  const location = useLocation();
  const fullname = location.state?.fullname || "";
  const [AssetsList, setAssetsList] = useState([]);
  const [showLoader, setLoader] = useState(false);
  const [sendImagePath, setImagePath] = useState("");
  const { data: pathImage } = useGetImagePathByIdQuery(sendImagePath);

  const [DocumentList, setDocumentList] = useState([]);
  const [openLightbox, setOpenLightBox] = useState(false);
  const [lightBoxViewImage, setImageInLightbox] = useState("");
  const { data: data, isLoading, refetch } = useGetAllAssetsOfUsersQuery(id);

  useEffect(() => {
    const userFromApi = data?.data ? data?.data : AssetsList;
    if (userFromApi !== undefined) {
      const filteredAssets = userFromApi?.filter(
        (asset) =>
          ["Plough Cattle", "Milch Cattle"].includes(asset.asset_type) &&
          asset?.asset_details !== null
      );
      setAssetsList(filteredAssets);
    }
    const Documnets = DocData?.data ? DocData?.data : DocumentList;
    if (Documnets?.media !== undefined) setDocumentList(Documnets?.media);
  }, [data]);
  console.log("all documents", AssetsList);

  // const AddModal = (updateButtonTag, list) => {
  //   if (updateButtonTag) {
  //     setSubmitButtonApi(true);
  //     setUpdateId(list.id);
  //   }

  //   let currentList = {
  //     asset_type: list.asset_type,
  //     asset_name: list.asset_name,
  //     asset_number: list.asset_number,
  //     asset_value: list.asset_value,
  //     asset_category: list.asset_category,
  //     asset_location: list.asset_location,
  //     asset_owner: list.asset_owner,
  //   };
  //   editGroup(currentList);
  //   setshowAddModal(true);
  // };
  // const handleClose = () => {
  //   setshowAddModal(false);
  //   setError(false);
  //   setSubmitButtonApi(false);
  //   setUpdateId("");
  //   editGroup({
  //     asset_type: "",
  //     asset_name: "",
  //     asset_number: "",
  //     asset_value: "",
  //     asset_category: "",
  //     asset_location: "",
  //     asset_owner: "",
  //   });
  //   disableSubmitBtn(false);
  // };
  // const onInputChange = (event) => {
  //   editGroup({
  //     ...Group,
  //     [event.target.name]: event.target.value,
  //   });
  // };

  // const AddFamilytSubmit = (e) => {
  //   e.preventDefault();
  //   disableSubmitBtn(true);

  //   if (!SubmitButtonApi) {
  //     createAssets({ id: id, payload: Group })
  //       .unwrap()
  //       .then((data) => {
  //         swal("Assets Created Successfully", {
  //           buttons: false,
  //           icon: "success",
  //           title: "Assets Created Detail",
  //           timer: 1500,
  //         });
  //         setshowAddModal(false);
  //         disableSubmitBtn(false);
  //         refetch();
  //       })
  //       .catch((error) => {
  //         toast.error("Error while Creating Member");
  //         disableSubmitBtn(false);
  //         return;
  //       });
  //   } else {
  //     updateAssets({ id: updateId, payload: Group })
  //       .unwrap()
  //       .then((data) => {
  //         // toast.success("Assets Updated")
  //         setshowAddModal(false);
  //         swal("Assets Updated Successfully", {
  //           buttons: false,
  //           icon: "success",
  //           title: "Assets Updated Detail",
  //           timer: 1500,
  //         });
  //         disableSubmitBtn(false);
  //         refetch();
  //       })
  //       .catch((error) => {
  //         toast.error("Error while Updating Member");
  //         disableSubmitBtn(false);
  //         return;
  //       });
  //   }
  // };
  const ReloadApplication = () => {
    setLoader(true);
    setTimeout(() => {
      refetch();
      setLoader(false);
    }, 1500);
  };
  const AddDocumentsModal = () => {
    setDocModal(true);
  };
  const showLargeImage = (imagePath) => {
    setImagePath(imagePath);
    setOpenLightBox(true);
  };
  useEffect(() => {
    if (pathImage) setImageInLightbox(pathImage.data.url);
  }, [pathImage]);

  return (
    <Card>
    <div
        className="d-flex justify-content-between  align-items-center "
        style={{ borderRadius: "5px",backgroundColor:"#f1f1f1" }}
      >
        <div className="heading-title mt-lg-0 mt-2 py-3">
                <h5
                  className="mx-4"
                  style={{
                    fontSize: "18px",
                    color: "black",
                  }}
                >
                  <i
                    className="mdi mdi-account-hard-hat me-2"
                    style={{ fontSize: "1.5rem" }}
                  ></i>
                  {fullname}
                </h5>
              </div>
        <div
          className="d-flex justify-content-end align-items-center flex-wrap"
          style={{ gap: "6px" }}
        >
          <Button
            className="bg-transparent text-black fs-6 reloadButton me-2"
            size="sm"
            onClick={ReloadApplication}
          >
           Reload <FontAwesomeIcon icon={faRotateLeft} />
          </Button>
          </div>
      </div>

      {isLoading ? (
        <div className="mt-4">
          <CardSkeleton />
        </div>
      ) : AssetsList.length === 0 ? (
        <FarmerNoResponse />
      ) : (
        <div className="border-lg  transparent_card">
          <div className="p-1 p-lg-0">
              <Col>
              
                      <div className="">
  {AssetsList &&
    AssetsList.map((fmd, index) => (
      <div className="d-lg-block d-md-none d-none transparent_card custom_mb" key={index}>
                      <Divider style={{ borderTop: "2px dotted orange",marginBottom:"5px" }} />
        
        <div className="p-3">
         

          <div className="row text-gray">
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="cattle_species"  value={fmd?.asset_details?.cattle_species || "N/A"} placeholder="N/A" disabled />
            </div>
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="cattle_age" value={fmd?.asset_details?.cattle_age || "N/A"} placeholder="N/A" disabled />
            </div>
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="cattle_color"  value={fmd?.asset_details?.cattle_color || "N/A"} placeholder="N/A" disabled />
            </div>
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="cattle_breed" value={fmd?.asset_details?.cattle_breed || "N/A"} placeholder="N/A" disabled />
            </div>
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="cattle_milkyield"  value={fmd?.asset_details?.cattle_milkyield || "N/A"} placeholder="N/A" disabled />
            </div>
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="cattle_tagging_date"  value={fmd?.asset_details?.cattle_tagging_date || "-"} placeholder="-" disabled />
            </div>
          </div>
          <div className="col-12 text-end p-2 mt-2 mb-0 d-lg-block d-md-none d-none">
                        
                        <Button
                          id="editDetails"
                          type=""
                          className="buttonOrangeDefaultColor"
                          onClick={() => AddDocumentsModal(true, fmd)}
                          size="sm"
                        >
                          View&nbsp;  <FontAwesomeIcon
              icon={faPenToSquare}
              
              style={{ color: "orange" }}
              className="cursor-pointer"
            />
                        </Button>
                     
                    </div>
        </div>
      </div>
    ))}
</div>



                      </Col>




















             

            <Col lg="12">
              <div className="d-flex flex-lg-row flex-md-row flex-wrap d-lg-none d-md-block d-block">
                {AssetsList && AssetsList.length > 0 ? (
                  AssetsList.map((item, index) => (
                    <Card
                      className="transparent_card custom_mb w-100 mb-2"
                      key={index}
                      lg="10"
                      md="5"
                      xs="12"
                    >
                      <CardBody className="p-1 p-lg-3">
                        <div className="hover-shadow d-lg-none d-md-block d-block rounded-3 bg-white p-3">
                          <CardTitle className="d-flex align-items-center justify-content-between mb-2">
                            <div className="d-flex align-items-center justify-content-between w-100">
                              <div>
                                <span
                                  className="font-weight-bold"
                                  style={{
                                    fontSize: "15px",
                                    color: "#333",
                                    marginLeft: "8px",
                                  }}
                                >
                                  Asset:
                                  <span className="text-success mx-1">
                                    {item.asset_name || "N/A"}
                                  </span>
                                </span>
                              </div>
                              <div>
                                <FontAwesomeIcon
                                  className="mx-1"
                                  icon={faEye}
                                  onClick={() => AddDocumentsModal(true, item)}
                                  style={{
                                    color: "orange",
                                    cursor: "pointer",
                                  }}
                                />
                              </div>
                            </div>
                          </CardTitle>
                          <hr
                            className="mt-0 mb-2"
                            style={{ borderColor: "#FF8C00" }}
                          />
                          <Table className="table mb-0">
                            <tbody>
                              {/* Cattle Species */}
                              <tr>
                                <th>Cattle Species:</th>
                                <td>
                                  <span>
                                    {item.asset_details?.cattle_species ||
                                      "N/A"}
                                  </span>
                                </td>
                              </tr>
                              {/* Cattle Age */}
                              <tr>
                                <th>Cattle Age:</th>
                                <td>
                                  <span>
                                    {item.asset_details?.cattle_age || "N/A"}
                                  </span>
                                </td>
                              </tr>
                              {/* Cattle Color */}
                              <tr>
                                <th>Cattle Color:</th>
                                <td>
                                  <span>
                                    {item.asset_details?.cattle_color || "N/A"}
                                  </span>
                                </td>
                              </tr>
                              {/* Cattle Breed */}
                              <tr>
                                <th>Cattle Breed:</th>
                                <td>
                                  <span>
                                    {item.asset_details?.cattle_breed || "N/A"}
                                  </span>
                                </td>
                              </tr>
                              {/* Cattle Milkyield */}
                              <tr>
                                <th>Cattle Milkyield:</th>
                                <td>
                                  <span>
                                    {item.asset_details?.cattle_milkyield ||
                                      "N/A"}
                                  </span>
                                </td>
                              </tr>
                              {/* Cattle Tagging Date */}
                              <tr>
                                <th>Tagging Date:</th>
                                <td>
                                  <span>
                                    {item.asset_details?.cattle_tagging_date ||
                                      "N/A"}
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </Card>
                  ))
                ) : (
                  <div className="text-center bg-white rounded-3 d-flex justify-content-center py-5 w-100">
                    <h5>No Data Available</h5>
                  </div>
                )}
              </div>
            </Col>
          </div>
        </div>





      )}

      <FarmerCattleMap cattleDetails={AssetsList} />
      {/* <Modal show={showAddModal} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "" }} className="fw-bold">
            {SubmitButtonApi ? "Update" : "Add"} Assets
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <form onSubmit={AddFamilytSubmit}>
            <Row className="text-gray">
              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="select"
                  required
                  name="asset_category"
                  value={Group.asset_category}
                  onChange={onInputChange}
                  style={{ padding: "12px" }}
                >
                  <option value="">Select</option>
                  <option value="movable">Movable</option>

                  <option value="immovable">Immovable</option>
                </CustomTextField>
              </Col>
              <Col lg="4" className="mb-2  ">
                <CustomTextField
                  type="select"
                  required
                  name="asset_type"
                  value={Group.asset_type}
                  onChange={onInputChange}
                  style={{ padding: "12px" }}
                >
                  <option value="">Select</option>
                  {Group.asset_category === "movable"
                    ? dropdownMovableData.map((item) => {
                        return <option value={item}>{item}</option>;
                      })
                    : Group.asset_category === "immovable"
                    ? dropdownImmMovableData.map((item) => {
                        return <option value={item}>{item}</option>;
                      })
                    : ""}
                </CustomTextField>
              </Col>
              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  required
                  name="asset_name"
                  value={Group.asset_name}
                  onChange={onInputChange}
                />
              </Col>

              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  required
                  name="asset_number"
                  value={Group.asset_number}
                  onChange={onInputChange}
                />
              </Col>

              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  required
                  name="asset_value"
                  value={Group.asset_value}
                  onChange={onInputChange}
                />
              </Col>

              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  required
                  name="asset_location"
                  value={Group.asset_location}
                  onChange={onInputChange}
                />
              </Col>

              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  required
                  name="asset_owner"
                  value={Group.asset_owner}
                  onChange={onInputChange}
                />
              </Col>
            </Row>
            <Button
              className={`btn btn-success  me-2 px-3 `}
              disabled={disableButton ? true : false}
              style={{ float: "right" }}
              size="sm"
              type="submit"
            >
              Submit &nbsp;
              {disableButton ? <Spinner animation="border" size="sm" /> : ""}
            </Button>

            {showError ? (
              <div style={{ color: "red" }}>
                All The fields are mandatory **
              </div>
            ) : (
              ""
            )}
          </form>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal> */}
      <Modal show={docModal} onHide={() => setDocModal(false)} size="xl">
        <Modal.Header className="px-3 py-2" closeButton>
          <Modal.Title className="fw-bold">Documents</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-1">
          <Row>
            {DocumentList.length === 0 ? (
              <div>No Documnets Found</div>
            ) : (
              <>
                <div>
                  <div className="p-2">
                    {DocumentList && (
                      <>
                        {DocumentList.map((item, index) => (
                          <div key={index} className="rounded-1 p-1">
                            <Table
                              responsive
                              hover
                              className="custom-border-table"
                            >
                              <thead>
                                <tr className="bg-secondary2 text-white text-center">
                                  <th className="d-lg-block d-md-block d-none">
                                    File Name
                                  </th>
                                  <th>Category</th>
                                  <th>Media Type</th>
                                  <th>File Type</th>
                                  <th>View</th>
                                </tr>
                              </thead>
                              <tbody>
                                {item.document_types
                                  .flatMap((innerItem) => innerItem.documents)
                                  .map((data, docIndex) => (
                                    <tr key={docIndex} className="text-center">
                                      <td className="d-lg-block d-md-block d-none">
                                        <i className="mdi mdi-file-document-multiple fs-5 text-warning"></i>
                                        &nbsp;
                                        {data.filename}
                                      </td>
                                      <td>
                                        {data.media_category.replace(/_/g, " ")}
                                      </td>
                                      <td
                                        style={{ color: "#1976D2" }}
                                        className="f14 font600"
                                      >
                                        {data.media_type.replace(/_/g, " ")}
                                      </td>
                                      <td>{data.file_type}</td>
                                      <td>
                                        <i
                                          className="mdi mdi-eye fs-5 text-warning cursor-pointer"
                                          onClick={() =>
                                            showLargeImage(data.path)
                                          }
                                        ></i>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </Table>
                          </div>
                        ))}
                      </>
                    )}
                  </div>

                  {openLightbox && (
                    <Lightbox
                      image={lightBoxViewImage}
                      title="Image Title"
                      onClose={() => setOpenLightBox(false)}
                    />
                  )}
                </div>
              </>
            )}
          </Row>
        </Modal.Body>
      </Modal>
    </Card>
  );
};

export default FarmerDetailsCattle;
